import React from "react";
import { Card } from "primereact/card";
import type { WeeklyStationMetric } from "../../../types/kpiDashboard";

interface Props {
  currentWeek: WeeklyStationMetric | null;
  onClick: () => void;
}

const StationsCard: React.FC<Props> = ({ currentWeek, onClick }) => (
  <Card
    className="h-full"
    style={{
      borderTop: "4px solid #3b82f6",
      cursor: "pointer",
      transition: "box-shadow 0.15s",
    }}
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } }}
    onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)"; }}
    onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.boxShadow = ""; }}
  >
    <div className="flex justify-content-between align-items-start">
      <p className="text-color-secondary text-xs font-semibold uppercase mb-2" style={{ letterSpacing: "0.05em" }}>
        Stations
      </p>
      <div className="flex align-items-center justify-content-center border-round"
           style={{ width: 44, height: 44, background: "#3b82f618", flexShrink: 0 }}>
        <svg width="22" height="22" viewBox="0 0 64 64" fill="none" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          {/* Station body */}
          <rect x="8" y="6" width="32" height="48" rx="4" fill="#3b82f618" stroke="#3b82f6"/>
          {/* Display screen */}
          <rect x="13" y="11" width="22" height="14" rx="2" stroke="#3b82f6"/>
          {/* Lightning bolt on screen */}
          <polyline points="23,13 20,20 24,20 21,27 26,19 22,19" fill="#3b82f6" stroke="none"/>
          {/* Cable out right side */}
          <path d="M40 32 Q52 32 52 40 L52 50" stroke="#3b82f6" fill="none"/>
          {/* Plug at end of cable */}
          <rect x="48" y="50" width="8" height="5" rx="1" fill="#3b82f6" stroke="none"/>
          <line x1="50" y1="55" x2="50" y2="58" stroke="#3b82f6"/>
          <line x1="54" y1="55" x2="54" y2="58" stroke="#3b82f6"/>
          {/* Bottom base */}
          <line x1="4" y1="54" x2="40" y2="54" stroke="#3b82f6"/>
        </svg>
      </div>
    </div>
    <div className="flex align-items-end gap-3 mb-1">
      <span className="text-3xl font-bold" style={{ color: "#22c55e" }}>
        {currentWeek?.active ?? "—"}
      </span>
      <span className="text-3xl font-bold" style={{ color: "#ef4444" }}>
        {currentWeek?.inactive ?? "—"}
      </span>
    </div>
    <div className="flex gap-3">
      <span className="text-xs font-semibold" style={{ color: "#22c55e" }}>Active</span>
      <span className="text-xs font-semibold" style={{ color: "#ef4444" }}>Inactive</span>
    </div>
    <p className="text-xs text-color-secondary mt-1 mb-0">Total fleet: {currentWeek?.total ?? "—"}</p>
  </Card>
);

export default StationsCard;
